import React from 'react';

export const defaultContextValue = {
  batchedDomains: {
    itemId: null,
    product: []
  }
};

const DataProviderContext = React.createContext(defaultContextValue);

export default DataProviderContext;
